import { ScrollableTabsBase } from "./app.tabs-base.js";

var image_with_text_tabs_default = (() => {
    if (customElements.get("image-with-text-tabs")) return;
    customElements.define("image-with-text-tabs", class ImageWithTextTabs extends ScrollableTabsBase {
        sectionSelector=".section--image-with-text";
        onTabStateChange(current, _panel, selected) {
            const tabIndex = current.dataset.iwtTab;
            if (tabIndex == null) return;
            const primary = this.querySelector(`[data-iwt-primary][data-iwt-tab="${CSS.escape(tabIndex)}"]`);
            if (primary) primary.setAttribute("aria-hidden", selected ? "false" : "true");
        }
    });
})();